import { render, staticRenderFns } from "./customer-stats.vue?vue&type=template&id=6843d4dc&"
import script from "./customer-stats.vue?vue&type=script&lang=js&"
export * from "./customer-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports